import noop from 'utils/noop';
import { Modal, ModalBody, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES } from 'ui/button';
import {
  Header,
  ButtonContainer,
  StyledButton,
  StyledDivider,
} from './DestinationSelectorModal.styled';
import { useDestinationSelector } from './useDestinationSelector';
import { DestinationSelectorContent } from './DestinationSelectorContent';
import { DESTINATION_SELECTOR_MODAL_CONTENT } from './DestinationSelectorModal.utils';

export const DestinationSelectorModal = () => {
  const { isModalOpen, handleSave } = useDestinationSelector();

  return isModalOpen ? (
    <Modal
      isModalOpen={isModalOpen}
      onClose={noop}
      withPortal
      id="destination-selector-modal"
      data-test="destination-selector-modal"
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <Header>{DESTINATION_SELECTOR_MODAL_CONTENT.header}</Header>

      <ModalBody>
        <DestinationSelectorContent />
      </ModalBody>

      <StyledDivider />

      <ButtonContainer>
        <StyledButton
          onClick={handleSave}
          data-test="destination-selector-save"
          size={BUTTON_SIZES.LARGE}
        >
          {DESTINATION_SELECTOR_MODAL_CONTENT.button}
        </StyledButton>
      </ButtonContainer>
    </Modal>
  ) : null;
};
